import { authorsMetaTag } from 'Store/constants/authorsMetaTag';

export const findDescAndTitle = tabName => {
  let descriptionAccordingToTab;
    
  switch (tabName) {
    case 'basketbol':
      descriptionAccordingToTab = authorsMetaTag.basketballPage;
      break;
    case 'futbol':
      descriptionAccordingToTab = authorsMetaTag.footballPage;
      break;
    case 'voleybol':
      descriptionAccordingToTab = authorsMetaTag.volleyballPage;
      break;
      
    case 'tenis':
      descriptionAccordingToTab = authorsMetaTag.tennisPage;
      break;

    default:
      descriptionAccordingToTab = authorsMetaTag.mainPage;
      break;
  }
  return descriptionAccordingToTab;
};